import { Button, type ButtonProps } from '@mui/material';

type ButtonPrimaryProps = {} & ButtonProps;

function ButtonPrimary({ children, ...props }: ButtonPrimaryProps) {
  return <Button {...props}>{children}</Button>;
}

export { ButtonPrimary };
